<div class="card">
  <div class="hd">
    <div class="title">{{ title }}</div>
  </div>
  <div class="body">
    <div class="placeholder" aria-hidden="true">

    </div>
  </div>
</div>
